import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Sets } from "@/components/Sets";
import { BundleAds } from "@/components/BundleAds";
import { TravelBanner } from "@/components/TravelBanner";
import { DollySection } from "@/components/DollySection";
import { Footer } from "@/components/Footer";
import CollectionPage from "@/components/CollectionPage";
import SetPage from "@/components/SetPage";
import ShopPage from "@/components/ShopPage";
import TributePage from "@/components/TributePage";
import BundlePage from "@/components/BundlePage";
import StoryPage from "@/components/StoryPage";
import CollectionsPage from "@/components/CollectionsPage";
import TravelPage from "@/components/TravelPage";

const Landing = () => (
  <main>
    <Hero />
    <EditorialMarquee />
    <Sets />
    <BundleAds />
    <TravelBanner />
    <DollySection />
  </main>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div id="top" className="grain min-h-screen bg-cream font-montserrat text-navy antialiased">
        <Header />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/collections/:slug" element={<CollectionPage />} />
          <Route path="/collections" element={<CollectionsPage />} />
          <Route path="/sets/:slug" element={<SetPage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/tribute" element={<TributePage />} />
          <Route path="/bundles/:slug" element={<BundlePage />} />
          <Route path="/story" element={<StoryPage />} />
          <Route path="/travel" element={<TravelPage />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
